import { DynamicIcon } from "../layout/Sidebar/DynamicIcon";
import PanelItemCard from "./PanelItemCard";
import React from "react";
import { useSidebarItems } from "@/context/SideBarItemsProvider";
import HandbookCard from "./HandbookCard";
import AddShortcutCard from "./AddShortcutCard";
import { ShortcutActions } from "./ShortcutActions";
import { useAdminStatus } from "@/hooks/useAdminStatus";
import { type RawNavItem } from "../layout/Sidebar/utils/NavItems";

function shortcutsIn(items: RawNavItem[]): RawNavItem[] {
  return items.flatMap((item) => (item.type === "folder" ? shortcutsIn(item.children ?? []) : [item]));
}

export default function PanelItemsSection() {
  const { deserializedNavItems: sidebarItems } = useSidebarItems();
  const { isAdmin } = useAdminStatus();
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      <HandbookCard />
      {shortcutsIn(sidebarItems ?? []).map((item) => (
        <PanelItemCard
          key={item.id + "card"}
          icon={
            <DynamicIcon
              name={item.icon}
              size={24}
              className="text-neutral-500"
              title={item.icon}
            />
          }
          title={item.name}
          url={item.link}
          actions={isAdmin ? <ShortcutActions item={item} /> : null}
        />
      ))}
      {isAdmin && <AddShortcutCard />}
    </div>
  );
}
